var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { round } from 'helpers/Utils';
import { observable, computed, action } from 'mobx';
import Packet from '../Packets/Packet';
import { TempSaleTicket } from './TempSaleTicket';
export class TempSalePacket extends TempSaleTicket {
    constructor(store) {
        super(store);
        this._hoursSelected = {};
        this._datesSelected = {};
        this.setHourToStretch = (stretch, hour) => {
            let temp = {};
            for (const key in this._hoursSelected) {
                if (this._hoursSelected.hasOwnProperty(key)) {
                    temp[key] = this._hoursSelected[key];
                }
            }
            const index = getIndexForMapeo(stretch);
            temp[index] = hour;
            this._hoursSelected = temp;
        };
        this.setDateToStretch = (stretch, date) => {
            let temp = {};
            for (const key in this._datesSelected) {
                if (this._datesSelected.hasOwnProperty(key)) {
                    temp[key] = this._datesSelected[key];
                }
            }
            const index = getIndexForMapeo(stretch);
            temp[index] = date;
            this._datesSelected = temp;
        };
        this.initDates = () => {
            this._packet.stretches.forEach(stretch => {
                const index = getIndexForMapeo(stretch);
                this._datesSelected[index] = new Date();
            });
            this._packet.collaboratorStretches.forEach(collaboratorStretch => {
                const index = getIndexForMapeo(collaboratorStretch);
                this._datesSelected[index] = new Date();
            });
        };
    }
    get hoursSelectedOk() {
        const stretchesWithHorasIda = this._packet.stretches.reduce((previousValue, currentValue) => {
            if (currentValue.horasIda && currentValue.horasIda.length > 0) {
                return ++previousValue;
            }
            return previousValue;
        }, 0);
        const collaboratorStretchesWithHorasIda = this._packet.collaboratorStretches.reduce((previousValue, currentValue) => {
            if (currentValue.horasIda && currentValue.horasIda.length > 0) {
                return ++previousValue;
            }
            return previousValue;
        }, 0);
        const entriesNumber = Object.entries(this._hoursSelected).length;
        return entriesNumber === stretchesWithHorasIda + collaboratorStretchesWithHorasIda;
    }
    get money() {
        return this._packet ? this._packet.primaryMoney.alphabeticCode : '';
    }
    get packet() {
        return this._packet;
    }
    get hoursSelected() {
        return this._hoursSelected;
    }
    get datesSelected() {
        return this._datesSelected;
    }
    resetHoursSelected() {
        this._hoursSelected = {};
    }
    setPacket(packet) {
        this._packet = new Packet(packet);
        super.setTax(this._packet.tax);
        this.initDates();
    }
    toJSON() {
        var _a, _b, _c, _d, _e, _f;
        const urlImage = ((_a = this._packet.dataweb) === null || _a === void 0 ? void 0 : _a.image1) || null;
        const result = {
            urlImage,
            packet_id: this._packet.id,
            numero: super.numero,
            datebook: super.datebook,
            datecheck: super.datecheck,
            user_id: super.user.id,
            username: super.username,
            discount: super.discount,
            discountReason: super.discountReason,
            typeDiscount: super.typeDiscount,
            totalDiscount: super.totalDiscount,
            netAmount: super.netAmount,
            taxAmount: super.taxAmount,
            taxName: super.taxName,
            total: round(super.total, 2),
            terminal: 'virtual',
            daterefund: null,
            userRefund: null,
            operationLine_id: this._packet.operationLine.id,
            operationLineName: this._packet.operationLine.name,
            businessUnitName: this._packet.operationLine.businessUnit.name,
            receiptLayout_id: this.packet.receiptLayout_id,
            tin: this._packet.operationLine.businessUnit.tin,
            // datevalited: super.datevalited, // '2019-06-17 09:23:54+02',
            codeDiscount: super.codeDiscount ? super.codeDiscount.toString() : null,
            printPrice: this.packet.printPrice,
            numberPrinted: 1,
            // timeExpiration: this.packet.timeExpiration,
            // timeAdvance: this.packet.timeAdvance,
            // timeDelay: this.packet.timeDelay,
            // timeUse: this.packet.timeUse,
            payments: super.payments,
            aditionalInfo: this.packet.aditionalInfo,
            lines: super.lines.map(line => line.toJSON()),
            tickets: this.tickets,
            collaboratorTickets: this.collaboratorTickets,
            packetName: this._packet.name,
            businessUnit_id: this._packet.operationLine.businessUnit.id,
            taxValue: super.taxValue,
            afiliateName: (_b = this.afiliate) === null || _b === void 0 ? void 0 : _b.name,
            afiliateCommission: (_c = this.afiliate) === null || _c === void 0 ? void 0 : _c.commission,
            afiliate_id: (_d = this.afiliate) === null || _d === void 0 ? void 0 : _d.id,
            typeCommission: (_e = this.afiliate) === null || _e === void 0 ? void 0 : _e.typeCommission,
            afiliateEmail: (_f = this.afiliate) === null || _f === void 0 ? void 0 : _f.email
        };
        console.log('TempSalePacket - toJSON - result: ', result);
        return result;
    }
}
__decorate([
    observable
], TempSalePacket.prototype, "_packet", void 0);
__decorate([
    observable
], TempSalePacket.prototype, "_hoursSelected", void 0);
__decorate([
    observable
], TempSalePacket.prototype, "_datesSelected", void 0);
__decorate([
    computed
], TempSalePacket.prototype, "hoursSelectedOk", null);
__decorate([
    action
], TempSalePacket.prototype, "resetHoursSelected", null);
__decorate([
    action
], TempSalePacket.prototype, "setHourToStretch", void 0);
__decorate([
    action
], TempSalePacket.prototype, "setDateToStretch", void 0);
__decorate([
    action
], TempSalePacket.prototype, "setPacket", null);
export const getTaxesFromExtraLines = (extraLines) => {
    if (!extraLines) {
        return {};
    }
    const taxes = {};
    for (let i = 0; i < extraLines.length; i++) {
        if (taxes[extraLines[i].taxName]) { // ya está
            taxes[extraLines[i].taxName] += extraLines[i].taxAmount;
        }
        else { // no está
            taxes[extraLines[i].taxName] = extraLines[i].taxAmount;
        }
    }
    return taxes;
};
export const getIndexForMapeo = (itemSelected) => {
    const isCollaboratorStretch = !!itemSelected.operator_id;
    return !isCollaboratorStretch ? itemSelected.id : String(itemSelected.id) + '_' + itemSelected.operator_id;
};



//////////////////
// WEBPACK FOOTER
// ./src/modules/TempSale/TempSalePacket.ts
// module id = 67
// module chunks = 0